'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/intl-format-cache/index.js
// module id = 202
// module chunks = 0 1 2 3 4 5 6